// @ts-nocheck
import {
    chain,
    DispatchCompleteLoadInvoices,
    RequestDataFromApi as baseRequestDataFromApi,
} from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoices";
import { getInvoices } from "@store/Modules/client-framework/src/Services/InvoiceService";
import { addToChainAfter, createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const RequestDataFromApi = createChainHandler("RequestDataFromApi", chain, async props => {
    try {
        props.apiResult = await getInvoices(props.apiParameter, props.getState()); // Store Custom Code
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({ type: "Data/Invoices/FailedToLoadInvoices" });
            return false;
        }

        throw error;
    }
});

replaceInChain(chain, baseRequestDataFromApi, RequestDataFromApi);

export const AfterCompleteLoadInvoices = createChainHandler("AfterCompleteLoadInvoices", chain, props => {
    props.dispatch({
        type: "Store/Data/Invoices/CompleteLoadInvoices",
        collection: props.apiResult,
        parameter: props.parameter,
    });
});

addToChainAfter(chain, DispatchCompleteLoadInvoices, AfterCompleteLoadInvoices);
